<template>
  <div>
    <CToaster 
      position="top-right"
      key="notifications"
    >
      <template v-for="(toast, index) in updates">
        <CToast
          :key="'toast' + index"
          :show="true"
          v-bind="toast"
          class="bg-success"
        >
          <div style="width:100%;cursor:pointer;" @click="goTo(toast)">
            {{toast.text}}
          </div>
        </CToast>
      </template>
    </CToaster>
  </div>
</template>
<script>
var methods = {}

methods.goTo = function (toast) {
  if (toast.type === 'new_order') {
    if (toast.order_group_id && toast.order_id) {
      this.$router.push('/order/' + toast.order_id + '/' + toast.order_group_id)
    } else if (toast.order_id) {
      this.$router.push('/order/' + toast.order_id)
    }
  } else if (toast.type === 'saved_order_favor') {
    this.$router.push('/create_order/' + toast.order_id + '/saved')
  }
}

export default {
  // ===Component name
  name: "SocketNotifications",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // channel: 'private:orderentry_database_private-user.12',
  // echo: {
  //     'App\Events\SendNotification': (payload, vm) => {
  //         console.log('blog post created', payload);
  //     },
  //     'SendNotification': (payload, vm) => {
  //         console.log('blog post deleted', payload);
  //     }
  // },
  // ====component Data properties
  data(){
      return{
        updates: []
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    // this.$echo.private(`user.${this.user.id}`)
    // .notification((notification) => {
    //     this.handleNotification(notification)
    // })
    // var socket = io.connect('http://localhost:6001')
    console.log('socket page')
    console.log(Echo)
    // this.$echo.private('orderentry_database_private-user.12').listen('SendNotification', (payload) => {
    //       console.log(payload);
    //   });
    // Echo.
    window.Echo.connector.socket.connect(function(){
        console.log('connected', Echo.socketId());
    });
    window.Echo.connector.socket.on('connection', function(attemptNumber){
        console.log('connected', attemptNumber);
    });
    var that = this
    window.Echo.private('user.'+ this.$store.state.user.id).notification((notification) => {
        console.log('ooooooo')
        console.log(notification);
        if (notification.type === "App\\Notifications\\SendNotification") {
          console.log('yes')
          // that.updates.push(notification.notification)
          var obj = {}
          for (var key in notification.notification) {
            obj[key] = notification.notification[key]
          }
          obj.position = 'top-right'
          obj.class= "bg-success"
          obj.header = 'New Order #' + notification.notification.order_id
          obj.autohide = 3000
          that.updates.push(obj)
          that.$store.commit('addNotification', notification.notification)
        } else if (notification.type === "App\\Notifications\\NewChatNotification") {
          var obj = {}
          for (var key in notification.chat) {
            obj[key] = notification.chat[key]
          }
          obj.position = 'top-right'
          obj.class= "bg-info"
          obj.header = 'New Chat Order#' + notification.chat.order_id
          obj.autohide = 3000
          that.updates.push(obj)
          that.$store.commit('addMessage', notification.chat)
        }
    });
    window.Echo.private('App.User.' + this.$store.state.user.id).listen('SendNotificationEvent', (payload) => {
      console.log('private works')
        console.log(payload);
    });
    // window.Echo.channel('orderentry_database_private-user').listen('Illuminate\Notifications\Events\BroadcastNotificationCreated', (payload) => {
    //     console.log(payload);
    // });
    // window.Echo.private('orderentry_database_private-user.12').notification('App\Events\SendNotification', (payload) => {
    //     console.log(payload);
    // });
    // window.Echo.channel('orderentry_database_private-user.' + this.$store.state.user.id).nofiticaion('BroadcastNotificationCreated', (e) => {
    //     console.log(e.name);
    // })
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
